import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Configuration } from "src/assets/Configuration";
import { StandardTrainingCategoryOverviewModel } from "src/app/models/standard-training-category/standard-training-category-overview.model";

@Injectable({
  providedIn: 'root'
})
export class StandardTrainingCategoryService {
  constructor(
    private http: HttpClient
  ) {}

  getAllStandardTrainingCategories(
    languageCode: string
  ): Observable<StandardTrainingCategoryOverviewModel[]> {
    let params = new HttpParams()
      .set('languageCode', languageCode);

    return this.http.get<StandardTrainingCategoryOverviewModel[]>(
      Configuration.getApiBaseUrl() + '/standard-training-category',
      { params }
    );
  }

  getStandardTrainingCategory(
    id: string,
    languageCode: string
  ): Observable<StandardTrainingCategoryOverviewModel> {
    let params = new HttpParams()
      .set('languageCode', languageCode);

    return this.http.get<StandardTrainingCategoryOverviewModel>(
      Configuration.getApiBaseUrl() + '/standard-training-category/' + id,
      { params }
    );
  }

  getAvailableStandardTrainingCategories(
    currentTrainingCategoryId: string | null,
    languageCode: string
  ): Observable<StandardTrainingCategoryOverviewModel[]> {
    let params = new HttpParams()
      .set('languageCode', languageCode);

    if (currentTrainingCategoryId) {
      params = params.set(
        'currentTrainingCategoryId',
        currentTrainingCategoryId
      );
    }

    return this.http.get<StandardTrainingCategoryOverviewModel[]>(
      Configuration.getApiBaseUrl() + '/standard-training-category/available',
      { params }
    );
  }
}